// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import KEYS from "../config/keys";

const firebaseConfig = {
  apiKey: KEYS.FIREBASE_API_KEY,
  authDomain: KEYS.FIREBASE_AUTH_DOMAIN,
  projectId: KEYS.FIREBASE_PROJECT_ID,
  storageBucket: KEYS.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: KEYS.FIREBASE_MESSAGING_SENDER_ID,
  appId: KEYS.FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firestore Database
export const db = getFirestore(app);
